export default "__VITE_ASSET__3e769525__"